export function today() {
  const newDate = new Date();
  newDate.setHours(newDate.getHours() + 0, 0, 0, 0);
  return newDate;
}
